import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {ConservazioneCaricaDocumentoDichiarazioniIntentoAttiveStep2Component
} from './conservazione-carica-documento-dichiarazioni-intento-attive-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-dichiarazioni-intento-attive-step2', {
            url: '/conservazione-carica-dichiarazioni-intento-attive',
            ncyBreadcrumb: {
                label: 'Carica Dichiarazioni Intento Attive',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-dichiarazioni-intento-attive-step2 flex="100"></conservazione-carica-documento-dichiarazioni-intento-attive-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoDichiarazioniIntentoAttiveStep2Module: string = ng
    .module('conservazione-carica-documento-dichiarazioni-intento-attive-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoDichiarazioniIntentoAttiveStep2', ConservazioneCaricaDocumentoDichiarazioniIntentoAttiveStep2Component)
    .config(stateConfig)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-dichiarazioni-intento-attive-step2/conservazione-carica-documento-dichiarazioni-intento-attive-step2.module.ts